// EN
export const accomMgmt = {
  common: {
    cancel: "Cancelar",
    save: "Salvar",
    update: "Atualizar",
    back: "Voltar",
    continue: "Continuar",
    optional: "(opcional)",
    optionalPlaceholder: "Opcional",
    processing: "Processando...",
    name: "Nome",
    description: "Descrição",
    nameRequired: "O nome é obrigatório.",
  },

  type: {
    apartment: "Apartamento de temporada",
    hotel: "Hotel",
    camping: "Camping",
    villa: "Villa",
  },

  step: {
    type: "Tipo",
    structure: "Estrutura",
    accommodation: "Acomodação",
  },

  step1: {
    title: "Que tipo de acomodação você tem?",
    subtitle: "Selecione o tipo de acomodação.",
    subtitleQuota: "Apenas os tipos com cota disponível no seu plano ficarão ativos.",
    subtitleFirst: "Como esta é a sua primeira acomodação, você pode escolher qualquer tipo.",
    remaining: "restante: {count}",
    loadingQuota: "Carregando a cota do seu plano…",
  },

  step2: {
    title: "Configure sua acomodação",
    subtitle:
      "Decida se será uma acomodação individual ou uma com vários calendários (várias unidades sob uma única acomodação).",
    singleTitle: "Um único espaço",
    singleChip: "1 calendário",
    singleDesc: "Alugue o apartamento inteiro usando um único calendário.",
    groupedTitle: "Vários espaços",
    groupedChip: "Vários calendários",
    groupedDesc: "Você aluga vários espaços independentes dentro do apartamento",
  },

  step3: {
    title: "Configure a acomodação principal",
    subtitle:
      "Este será o “contêiner” (Anúncio) que agrupa vários calendários. Ex.: “Suíte do Castelo”.",
    panelTitle: "Escolha uma opção",
    availableCount: "Você tem {count} acomodações agrupadas disponíveis.",
    noneAvailable: "Nenhum anúncio agrupado disponível para este tipo (crie um novo).",
    newTitle: "Criar uma nova acomodação principal",
    newDesc: "Você define o nome da acomodação principal.",
    nameLabel: "Nome da acomodação principal",
    namePlaceholder: "Ex.: Suíte do Castelo",
    nameHelp: "Este nome será salvo e você poderá agrupar vários calendários.",
    minChars: "Digite pelo menos 3 caracteres.",
    existingTitle: "Adicionar a uma acomodação existente",
    existingDesc: "A unidade ficará dentro de uma acomodação que você já criou.",
    selectLabel: "Selecione a acomodação",
    selectPlaceholder: "Selecione uma acomodação…",
    listingOption: "{name} · {units} unidade(s)",
    ready: "Pronto",
    noneForType: "Você não tem acomodações agrupadas disponíveis para este tipo.",
    tip: "Dica: esta “principal” será o contêiner ao qual a nova unidade é adicionada.",
  },

  preview: {
    tab: "suaacomodacao",
    perNight: "/noite",
    book: "Reservar",
    locationPlaceholder: "País, cidade, rua",
    guests: "{count} hóspede | {count} hóspedes",
    bedrooms: "{count} quarto | {count} quartos",
    bathrooms: "{count} banheiro | {count} banheiros",
    amenitiesTitle: "Comodidades",
    amenitiesEmpty: "Selecione para adicionar comodidades à sua acomodação",
    locationTitle: "Localização",
    locationEmpty: "Defina a localização",
    descriptionTitle: "Descrição",
    descriptionEmpty: "Selecione para adicionar uma descrição à sua acomodação",
    namePlaceholder: "Nome da acomodação",
    amenity: {
      air_conditioning: "Ar-condicionado",
      heating: "Aquecimento central",
      parking: "Vaga de estacionamento",
      oven: "Forno e cooktop",
      pets_allowed: "Aceita animais de estimação",
      wifi: "Internet WiFi",
      essentials: "Itens essenciais",
      washing_machine: "Máquina de lavar",
      children_allowed: "Aceita crianças",
      refrigerator: "Geladeira",
    },
  },

  amenities: {
    title: "Equipamentos e comodidades",
    subtitle: "Conte aos hóspedes o que sua acomodação oferece para que saibam o que esperar.",
    searchPlaceholder: "Buscar comodidade…",
    selectedCount:
      "{count} comodidade selecionada | {count} comodidades selecionadas",
    noResults: 'Nenhuma comodidade encontrada para "{search}".',
    cat: {
      all: "Todas",
      basics: "Essenciais",
      bathroom: "Banheiro",
      bedroom: "Quarto e lavanderia",
      kitchen: "Cozinha e sala de jantar",
      outdoor: "Área externa",
      leisure: "Lazer e entretenimento",
      safety: "Segurança",
      family: "Famílias",
      parking: "Estacionamento",
      services: "Serviços",
      connectivity: "Conectividade",
      accessibility: "Acessibilidade",
    },
    item: {
      wifi: "WiFi",
      essentials: "Itens essenciais",
      air_conditioning: "Ar-condicionado",
      heating: "Aquecimento",
      indoor_fireplace: "Lareira interior",
      hot_water: "Água quente",
      hangers: "Cabides",
      bed_linen: "Roupa de cama",
      towels: "Toalhas",
      shampoo: "Shampoo",
      shower_gel: "Sabonete líquido",
      conditioner: "Condicionador",
      hair_dryer: "Secador de cabelo",
      bathtub: "Banheira",
      bidet: "Bidê",
      jacuzzi: "Jacuzzi",
      outdoor_shower: "Chuveiro externo",
      washing_machine: "Máquina de lavar",
      dryer: "Secadora",
      iron: "Ferro de passar",
      clothes_drying_rack: "Varal",
      extra_pillows: "Travesseiros e cobertores extras",
      wardrobe: "Espaço para guardar roupas",
      blackout_curtains: "Persianas ou cortinas blackout",
      nearby_laundry: "Lavanderia nas proximidades",
      oven: "Forno",
      refrigerator: "Geladeira",
      freezer: "Freezer",
      microwave: "Micro-ondas",
      dishwasher: "Lava-louças",
      cooking_basics: "Utensílios básicos de cozinha",
      plates_cutlery: "Louças e talheres",
      wine_glasses: "Taças de vinho",
      coffee_maker: "Cafeteira",
      coffee: "Café",
      kettle: "Chaleira",
      toaster: "Torradeira",
      blender: "Liquidificador",
      rice_cooker: "Panela de arroz elétrica",
      bread_maker: "Máquina de pão",
      mini_fridge: "Frigobar",
      stovetop: "Cooktop",
      dining_table: "Mesa de jantar",
      baking_sheet: "Assadeira",
      bbq_grill: "Churrasqueira",
      bbq_utensils: "Utensílios para churrasco",
      outdoor_kitchen: "Cozinha externa",
      outdoor_dining: "Área de refeições ao ar livre",
      breakfast: "Café da manhã",
      pool: "Piscina",
      shared_pool: "Piscina compartilhada",
      garden: "Quintal",
      patio_balcony: "Pátio ou varanda",
      outdoor_furniture: "Móveis externos",
      sun_loungers: "Espreguiçadeiras",
      hammock: "Rede de descanso",
      fire_pit: "Fogueira externa",
      shared_fireplace: "Lareira em área comum",
      sauna: "Sauna",
      beach_essentials: "Itens de praia",
      beach_access: "Acesso à praia",
      lake_access: "Acesso ao lago",
      resort_access: "Acesso ao resort",
      waterfront: "Frente para a água",
      dock: "Píer para barcos",
      kayak: "Caiaque",
      bikes: "Bicicletas",
      ski_slope: "Pista de esqui",
      outdoor_playground: "Playground ao ar livre",
      tv: "TV",
      sound_system: "Sistema de som",
      record_player: "Toca-discos",
      piano: "Piano",
      gym: "Academia",
      exercise_equipment: "Equipamentos de ginástica",
      games: "Jogos de tabuleiro",
      giant_games: "Jogos gigantes",
      pool_table: "Mesa de sinuca",
      ping_pong: "Mesa de ping-pong",
      bowling: "Pista de boliche",
      arcade: "Fliperama",
      minigolf: "Minigolfe",
      batting_cage: "Gaiola de rebatidas",
      ice_rink: "Pista de hóquei no gelo",
      laser_tag: "Laser tag",
      skate_ramp: "Rampa de skate",
      climbing_wall: "Parede de escalada",
      game_console: "Console de videogame",
      books: "Livros e material de leitura",
      cinema: "Cinema",
      themed_room: "Quarto temático",
      smoke_detector: "Detector de fumaça",
      co_detector: "Detector de monóxido de carbono",
      fire_extinguisher: "Extintor de incêndio",
      first_aid_kit: "Kit de primeiros socorros",
      fire_guard: "Proteção para lareira",
      safe: "Cofre",
      gated_community: "Condomínio fechado",
      security_cameras: "Câmeras de segurança",
      children_allowed: "Aceita crianças",
      crib: "Berço",
      travel_cot: "Berço portátil",
      baby_bath: "Banheira para bebê",
      baby_safety_gates: "Portões de segurança para bebês",
      changing_table: "Trocador",
      high_chair: "Cadeira de alimentação",
      children_plates: "Louças e talheres infantis",
      children_books_toys: "Livros e brinquedos infantis",
      kids_bikes: "Bicicletas infantis",
      outlet_covers: "Protetores de tomada",
      table_corner_guards: "Protetores de quina de mesa",
      window_guards: "Grades de proteção nas janelas",
      baby_monitor: "Babá eletrônica",
      children_game_room: "Sala de jogos infantil",
      babysitter_recommendations: "Indicações de babá",
      parking: "Estacionamento gratuito na propriedade",
      free_street_parking: "Estacionamento gratuito na rua",
      paid_parking_on_premises: "Estacionamento pago na propriedade",
      paid_parking_off_premises: "Estacionamento pago fora da propriedade",
      ev_charger: "Carregador para carro elétrico",
      e_bike_charger: "Carregador para e-bike",
      pets_allowed: "Aceita animais de estimação",
      long_term_stays: "Disponível para estadias longas",
      luggage_dropoff: "Permite guardar bagagem",
      cleaning_during_stay: "Limpeza disponível durante a estadia",
      concierge: "Concierge",
      cleaning_products: "Produtos de limpeza",
      recycling: "Lixeiras de reciclagem",
      compactor: "Compactador de lixo",
      compost: "Composteira",
      solar_panels: "Painéis solares",
      workspace: "Espaço de trabalho",
      private_entrance: "Entrada privativa",
      private_lounge: "Sala de estar privativa",
      mosquito_net: "Mosquiteiro",
      ceiling_fan: "Ventilador de teto",
      portable_fans: "Ventiladores portáteis",
      ethernet: "Conexão Ethernet",
      mobile_wifi: "WiFi móvel",
      single_floor: "Acomodação em um único andar",
      elevator: "Elevador",
    },
  },

  room: {
    createTitle: "Cadastrar tipo de quarto",
    editTitle: "Atualizar tipo de quarto",
    namePlaceholder: "Ex.: Quarto Duplo",
    countLabel: "Número de quartos deste tipo",
    countPlaceholder: "Ex.: 20",
    countHint: "Este é o inventário total do tipo. Ex.: “Duplo” = 20 quartos.",
    capacityLabel: "Capacidade total (máx. de hóspedes)",
    capacityPlaceholder: "Ex.: 5",
    capacityHint:
      "Este é o limite real de hóspedes. Mesmo que você defina máximos por categoria, o total prevalece.",
    maxAdults: "Máx. de adultos",
    maxChildren: "Máx. de crianças",
    maxInfants: "Máx. de bebês",
    importantLabel: "Importante:",
    capacityNote: "estes são limites por categoria. O total permitido é definido por “Capacidade total”.",
    physicalTitle: "Quartos físicos (RoomInstances)",
    physicalDesc: "Ative se quiser gerenciar 101/102, manutenção por quarto e fechaduras.",
    generateLabel: "Gerar/Ajustar quartos físicos automaticamente",
    generatorTitle: "Gerador de códigos",
    prefixLabel: "Prefixo",
    prefixPlaceholder: "Ex.: 10 ou A-",
    prefixHint: "Ex.: prefixo “10” + início 1 => 101,102...",
    startLabel: "Início",
    paddingLabel: "Preenchimento",
    paddingHint: "Ex.: preenchimento 3 => 001,002,003",
    nameModeType: "Somente tipo",
    nameModeTypeCode: "Tipo + código",
    defaultDescLabel: "Descrição padrão",
    willCreatePre: "Até",
    willCreatePost: "quartos físicos serão criados ou ajustados automaticamente.",
    errors: {
      saveFallback: "Erro ao salvar o tipo de quarto.",
      capacityMin: "A capacidade total deve ser de pelo menos 1.",
      adultsMin: "Deve haver pelo menos 1 adulto permitido.",
      adultsMax: "O limite de adultos não pode ser maior que a capacidade total.",
      childrenRange: "O limite de crianças deve estar entre 0 e a capacidade total.",
      infantsRange: "O limite de bebês deve estar entre 0 e a capacidade total.",
      roomsMin: "O número de quartos deve ser de pelo menos 1.",
      notAuth: "Usuário não autenticado.",
    },
    toasts: {
      updated: "Tipo atualizado.",
      created: "Tipo criado.",
      roomsSynced: "Quartos físicos gerados/ajustados com sucesso.",
    },
  },

  rate: {
    registerHeader: "Cadastrar tipo de quarto",
    editHeader: "Atualizar tarifa - {name}",
    createHeader: "Cadastrar tarifa - {name}",
    processing: "Processando, aguarde.",
    general: "Geral",
    namePlaceholder: "Nome personalizado",
    validityLabel: "Período de validade",
    permanent: "Permanente",
    custom: "Personalizado",
    startDatePlaceholder: "Data de início",
    endDatePlaceholder: "Data de término",
    validityNoteCustom: "Período de validade da tarifa (opcional)",
    validityNotePermanent: "Tarifa válida permanentemente",
    pricePerNight: "Preço por noite",
    taxIncluded: "Impostos incluídos",
    occupancy: "Ocupação",
    guestsNumber: "Número de hóspedes",
    minStay: "Estadia mínima",
    minStayNote: "Noites mínimas a cobrar",
    maxStay: "Estadia máxima",
    maxStayNote: "Limite de noites para reservar",
    errors: {
      rangeRequired: "Você deve selecionar um período de datas válido",
      startAfterEnd: "A data de início não pode ser posterior à data de término",
      minStay:
        "A estadia mínima é de {minStay} noites, mas o período selecionado tem {nights} noites",
    },
  },
};